import { WecdevErrorMessage } from './wecdev-error-message';

export enum WecdevErrorType {
    SERVER_ERROR = 'SERVER_ERROR',
    AUTHORIZATION_ERROR = 'AUTHORIZATION_ERROR',
    AUTHENTICATION_ERROR = 'AUTHENTICATION_ERROR',
    VALIDATION_ERROR = 'VALIDATION_ERROR',
}

export class WecdevError {
    public static CLASS_NAME: string = 'WecdevError';
    public static ERROR_HANDLED: string = 'ERROR_HANDLED';

    public type?: WecdevErrorType;
    public message?: string;
    public errors?: Array<WecdevErrorMessage>;

    constructor(type: WecdevErrorType, message: string, errors?: Array<WecdevErrorMessage>) {
        this.type = type;
        this.message = message;
        this.errors = errors;
    }
}
